import domReady from '@wordpress/dom-ready';

domReady(() => {
  const submitBtns = document.querySelectorAll('.facetwpSubmit');

  if ('undefined' !== typeof window.FWP && 0 < submitBtns.length) {
    window.FWP.auto_refresh = false;

    submitBtns.forEach((btn) => {
      btn.addEventListener('click', function () {
        window.FWP.refresh();
      });
    });
    window.addEventListener('keydown', function (e) {
      if (e.keyCode === 13) {
        //if enter is pressed
        window.FWP.refresh();
      }
    });
  }
});
